<template>
  <ui-ask-danger ref="ask"/>

  <ui-simple-modal v-model="showUser" :ok-text="form.id? 'Сохранить' : 'Добавить'" @ok="save">
    <template v-if="form.id" #title>Редактирование участника #{{ form.id }}</template>
    <template v-else #title>Добавление участника</template>
    <p class="pb-4 text-gray-600 text-md">
      Внесите данные участника и укажите куратора (при наличии).
    </p>
    <ui-form :errors="errors" class="space-y-4">
      <ui-form-item label="ФИО" required name="name">
        <ui-form-text v-model="form.name"/>
      </ui-form-item>
      <ui-form-item label="Образовательное учреждение" required name="school_id">
        <ui-form-select-custom v-model="form.school" :items="schools"/>
        <template #help>
          <p class="mt-2 text-sm text-gray-500">
            Учреждения можно добавить в
            <router-link class="link" :to="{name: 'UserSchools', params: {user_id: user_id}}">профиле</router-link>
          </p>
        </template>
      </ui-form-item>
      <ui-form-item label="Класс/Группа" required name="group">
        <ui-form-text v-model="form.group"/>
      </ui-form-item>
      <ui-form-item label="Участие с куратором" required name="has_curator" :child-label="true">
        <ui-form-checkbox v-model="form.has_curator"/>
      </ui-form-item>
      <ui-form-item v-show="form.has_curator" label="ФИО куратор" required name="curator_name">
        <ui-form-text v-model="form.curator_name"/>
      </ui-form-item>
      <ui-form-item v-show="form.has_curator" label="Email куратора" name="curator_email">
        <ui-form-email v-model="form.curator_email"/>
      </ui-form-item>
    </ui-form>
  </ui-simple-modal>

  <div class="bg-white shadow sm:rounded-lg  px-4 py-5 border-b border-gray-200 sm:px-6">
    <ui-header-card :head="`Заявка на участие ${ id }`">
      {{ user_event.event.name }}
      <template #button>
        <ui-button-outline @click="destroyUserEvent" color="red">
          <TrashIcon class="w-5 h-5 mr-1"/>
          Удалить заявку
        </ui-button-outline>
      </template>
    </ui-header-card>

    <div class="py-5">
      <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Full name</dt>
          <dd class="mt-1 text-sm text-gray-900">Margot Foster</dd>
        </div>
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Application for</dt>
          <dd class="mt-1 text-sm text-gray-900">Backend Developer</dd>
        </div>
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Email address</dt>
          <dd class="mt-1 text-sm text-gray-900">margotfoster@example.com</dd>
        </div>
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Salary expectation</dt>
          <dd class="mt-1 text-sm text-gray-900">$120,000</dd>
        </div>
        <div class="sm:col-span-2">
          <dt class="text-sm font-medium text-gray-500">About</dt>
          <dd class="mt-1 text-sm text-gray-900">Fugiat ipsum ipsum deserunt culpa aute sint do nostrud anim incididunt
            cillum culpa consequat. Excepteur qui ipsum aliquip consequat sint. Sit id mollit nulla mollit nostrud in ea
            officia proident. Irure nostrud pariatur mollit ad adipisicing reprehenderit deserunt qui eu.
          </dd>
        </div>
        <div class="sm:col-span-2">
          <dt class="text-sm font-medium text-gray-500">Файлы для загрузки</dt>
          <dd class="mt-1 text-sm text-gray-900">
            <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
              <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                <div class="w-0 flex-1 flex items-center">
                  <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true"/>
                  <span class="ml-2 flex-1 w-0 truncate">Задания мероприятия #{{ user_event.event.id }}.pdf </span>
                </div>
                <div class="ml-4 flex-shrink-0">
                  <a href="#" class="font-medium text-primary-600 hover:text-primary-500"> Скачать </a>
                </div>
              </li>
              <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                <div class="w-0 flex-1 flex items-center">
                  <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true"/>
                  <span class="ml-2 flex-1 w-0 truncate">Бланки ответов (для выдачи детям) #{{
                      user_event.event.id
                    }}.pdf </span>
                </div>
                <div class="ml-4 flex-shrink-0">
                  <a href="#" class="font-medium text-primary-600 hover:text-primary-500"> Скачать </a>
                </div>
              </li>
            </ul>
          </dd>
        </div>
      </dl>
    </div>


    <div class="mt-5">
      <div>
        <ui-table :rows="user_event.members">
          <ui-table-col label="#" prop="index"/>
          <ui-table-col label="ФИО">
            <template #default="{row}">
              <button @click="_item('edit', row)" type="button" class="link"> {{ row.name }}</button>
            </template>
          </ui-table-col>
          <ui-table-col label="Обр. учреждение" prop="school.name"/>
          <ui-table-col label="Класс/Группа" prop="group"/>
          <ui-table-col label="Куратор">
            <template #default="{row}">
              <span v-if="row.has_curator">{{ row.curator_name }}</span>
              <ui-badge v-else color="orange">не указан</ui-badge>
            </template>
          </ui-table-col>
          <ui-table-col label="Ответы">
            <template #default="{row}">
              <span v-if="row.has_curator" class="text-primary-600">загрузить</span>
              <span v-else class="text-green-700">изменить</span>
            </template>
          </ui-table-col>
          <ui-table-col label="" class="text-right">
            <template #default="{row}">
              <ui-dropdown-actions :actions="['edit', 'hr', 'remove']" @ok="c=>{_item(c, row)}"/>
            </template>
          </ui-table-col>
        </ui-table>
        <ui-empty-rows v-if="user_event.members.length ===0" @btnClick="clickNewUser">
          <p>Вы еще не добавили участников мероприятия в заявку.</p>
        </ui-empty-rows>
        <ui-divider-with-add-button v-else class="mt-4" @click="clickNewUser" btn-text="Добавить участника"/>
      </div>
    </div>

    <div class="mt-5">
      <div class="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">

        <div class="mt-10 lg:mt-0">
          <div v-if="user_event.event.has_coupon">
            <h3 class="text-lg leading-6 font-medium text-gray-900">Купон для скидки</h3>
            <div class="mt-2 max-w-xl text-sm text-gray-500">
              <p>Если у вас есть купон, вы можете ввести его и получить скидку на оплату</p>
            </div>
            <form class="mt-5 sm:flex sm:items-center" @submit.prevent.stop="checkCoupon">
              <div class="w-full sm:max-w-xs">
                <input type="text" v-model.trim="coupon" required
                       class="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       placeholder="Пример: VK1805200"/>
              </div>
              <ui-button class="sm:ml-3" @click="checkCoupon">Применить</ui-button>
            </form>
            <div class="mt-4" v-if="user_event.coupon">
              <span
                  class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-green-100 text-green-700">
                <span class="font-semibold">{{ user_event.coupon.code }}</span><span
                  class="text-xs mx-1"> -{{ user_event.coupon.discount }} руб.</span>
              <button type="button" @click="destroyCoupon"
                      class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-green-500 hover:bg-green-200 hover:text-green-500 focus:outline-none focus:bg-green-500 focus:text-white">
                <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                  <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
                </svg>
              </button>
            </span>
            </div>
            <div class="mt-5" v-if="coupon_error">
              <ui-alert>
                <p class="text-sm text-yellow-700">Купон не существует, или его нельзя применить к мероприятию</p>
              </ui-alert>
            </div>
          </div>
        </div>

        <!-- Order summary -->
        <div class="mt-10 lg:mt-0">

          <dl class="py-6 space-y-6">
            <div class="flex items-center justify-between">
              <dt class="text-sm">Количество участников</dt>
              <dd class="text-sm font-medium text-gray-900">{{ user_event.members.length }}</dd>
            </div>
            <div class="flex items-center justify-between border-t border-gray-200 pt-4">
              <dt class="text-base font-medium">Итого</dt>
              <dd class="text-base text-gray-900">
                <span class="block font-medium">
                  {{
                    (user_event.event.cost - (user_event.has_coupon ? user_event.coupon.discount : 0)) * user_event.members.length
                  }} руб.
                </span>
                <span v-if="user_event.coupon" class="relative block text-sm text-red-500 line-through">&nbsp;
                  {{ user_event.event.cost * user_event.members.length }} руб.&nbsp;
                </span>
              </dd>
            </div>
          </dl>

          <div class="py-6 text-right">
            <ui-button size="lg">Оплатить и завершить</ui-button>
          </div>

        </div>
      </div>
    </div>

  </div>


</template>

<script>
import UiTable from "@/components/ui/table/UiTable";
import UiTableCol from "@/components/ui/table/UiTableCol";
import UiDropdownActions from "@/components/ui/dropdown/UiDropdownActions";
import UiSimpleModal from "@/components/ui/modal/UiSimpleModal";
import UiForm from "@/components/ui/form/UiForm";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormText from "@/components/ui/form/UiFormText";
import UiFormSelectCustom from "@/components/ui/form/select-menus/UiFormSelectCustom";
import UiFormCheckbox from "@/components/ui/form/UiFormCheckbox";
import UiFormEmail from "@/components/ui/form/UiFormEmail";
import {mapGetters} from "vuex";
import UiBadge from "@/components/ui/elements/badges/UiBadge";
import UiHeaderCard from "@/components/ui/headings/UiHeaderCard";
import {PaperClipIcon} from '@heroicons/vue/solid'
import UiAskDanger from "@/components/ui/ask/UiAskDanger";
import UiDividerWithAddButton from "@/components/ui/dividers/UiDividerWithAddButton";
import UiEmptyRows from "@/components/ui/empty-states/UiEmptyRows";
import UiButtonOutline from "@/components/ui/button/UiButtonOutline";
import {TrashIcon} from "@heroicons/vue/outline";
import UiButton from "@/components/ui/button/UiButton";
import UiAlert from "@/components/ui/alert/UiAlert";

export default {
  components: {
    UiAlert,
    UiButton,
    UiButtonOutline,
    UiEmptyRows,
    UiDividerWithAddButton,
    UiAskDanger,
    UiHeaderCard,
    UiBadge,
    UiFormEmail,
    UiFormCheckbox,
    UiFormSelectCustom,
    UiFormText, UiFormItem, UiForm, UiSimpleModal, UiDropdownActions, UiTableCol, UiTable, PaperClipIcon,
    TrashIcon
  },
  props: ['id'],
  data() {
    return {
      showUser: false,
      coupon: '',
      coupon_error: false,
      user_event: {
        members: [],
        event: {
          name: ''
        }
      },
      errors: {},
      form: {
        id: null,
        name: '',
        school: {},
        group: '',
        has_curator: false,
        curator_name: '',
        curator_email: ''
      }
    }
  },
  computed: {
    ...mapGetters('school', {schools: 'all'}),
    ...mapGetters('account', {user_id: 'id'})
  },
  methods: {
    async save() {
      const form = {
        name: this.form.name,
        school_id: this.form.school.id ?? null,
        group: this.form.group,
        has_curator: this.form.has_curator,
        curator_name: this.form.curator_name,
        curator_email: this.form.curator_email
      }
      this.errors = {}

      try {
        if (this.form.id) {
          const {member, members} = await this.$api.user_events.update_member(this.user_event.id, this.form.id, form)
          this.$store.dispatch('alerts/success', {text: `Данные участника ${member.name} сохранены`})
          this.user_event.members = members
        } else {
          const {member, members} = await this.$api.user_events.store_member(this.user_event.id, form)
          this.$store.dispatch('alerts/success', {text: `Участник ${member.name} добавлен`})
          this.user_event.members = members
        }
        this.showUser = false;
        this.form = {id: null, name: '', school: {}, group: '', has_curator: false, curator_name: '', curator_email: ''}
      } catch (e) {
        this.errors = e;
      }

    },

    clickNewUser() {
      this.form = {id: null, name: '', school: {}, group: '', has_curator: false, curator_name: '', curator_email: ''}
      this.showUser = true
    },
    destroyUserEvent() {
      this.$refs.ask.show({title: `Удалить заявку #${this.user_event.id}?`}).then(async () => {
        await this.$api.user_events.destroy(this.user_event.id);
        this.$store.dispatch('alerts/success', {text: `Заявка на участие #${this.user_event.id} удалена`})
        this.$router.push({name: 'Home'})
      })
    },
    _item(cmd, item) {

      switch (cmd) {
        case 'remove':
          this.$refs.ask.show({title: `Удалить участника ${item.name} из заявки?`}).then(async () => {
            const {members} = await this.$api.user_events.destroy_member(item.user_event_id, item.id)
            this.$store.dispatch('alerts/success', {text: `Участник ${item.name} удален`})
            this.user_event.members = members
          })
          break;
        case 'edit':
          this.form = {
            id: item.id,
            name: item.name,
            school: item.school,
            group: item.group,
            has_curator: item.has_curator,
            curator_name: item.curator_name,
            curator_email: item.curator_email
          }
          this.showUser = true;

          break;
      }
    },
    async checkCoupon() {
      this.coupon_error = false;
      try {
        const {coupon} = await this.$api.user_events.check_coupon(this.user_event.id, this.coupon)
        this.$store.dispatch('alerts/success', {text: `Купон  #${this.coupon} успешно применен`})
        this.coupon = ''
        this.user_event.has_coupon = true;
        this.user_event.coupon = coupon;

      } catch (e) {
        this.coupon_error = true;
      }

    },
    async destroyCoupon() {
      this.coupon_error = false;
      await this.$api.user_events.destroy_coupon(this.user_event.id)
      this.user_event.has_coupon = false;
      this.user_event.coupon = null;
    }

  },
  async mounted() {
    this.user_event = await this.$api.user_events.get(this.id)
  }

}
</script>
